import { render, staticRenderFns } from "./commentModal.vue?vue&type=template&id=dea63a74&scoped=true&"
import script from "./commentModal.vue?vue&type=script&lang=js&"
export * from "./commentModal.vue?vue&type=script&lang=js&"
import style0 from "./commentModal.vue?vue&type=style&index=0&id=dea63a74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea63a74",
  null
  
)

export default component.exports